import { I18n } from "@lingui/core";
import { t } from "@lingui/macro";
import { SETTINGS_INSIGHTS } from "../../utils/routes";

type LangFunc = (i18n: I18n) => string;
type AppLink = { label: string | LangFunc; href: string };
type AdminLinks = { [key: string]: AppLink | undefined };
type UserDetails = { name?: string; initials: string };

function getInitials(displayName = "") {
  return displayName
    .split(" ")
    .map((name) => name[0])
    .join("");
}

export function getClientRoutes(user: Insite.AppState["auth"]["user"]) {
  const appLinks: AppLink[] = [];
  const adminLinks: AdminLinks = {
    support: {
      label: (i18n) => i18n._(t("user_menu.support")`Support`),
      href: "mailto:support@conserveitiot.com",
    },
    profile: undefined,
    userAdmin: undefined,
    groupAdmin: undefined,
    siteSettings: undefined,
  };

  const userDetails: UserDetails = {
    name: "",
    initials: "",
  };

  // UserMenu and userDetails conditions
  if (user.token) {
    adminLinks.profile = {
      label: (i18n) => i18n._(t("user_menu.my_profile")`My Profile`),
      href: "/profile",
    };
    userDetails.name = user.display_name || "";
    userDetails.initials = getInitials(user.display_name || "");
  }

  if (user.access && user.access.includes("userAdmin")) {
    adminLinks.userAdmin = {
      label: (i18n) => i18n._(t("user_menu.user_settings")`User Settings`),
      href: "/users",
    };
  }

  if (user.access && user.access.includes("groupAdmin")) {
    adminLinks.groupAdmin = {
      label: (i18n) => i18n._(t("user_menu.group_settings")`Group Settings`),
      href: "/groups",
    };
  }

  if (
    user.access &&
    user.groups !== undefined &&
    user.groups.includes("ConserveIt")
  ) {
    adminLinks.siteSettings = {
      label: (i18n) =>
        i18n._(t("user_menu.project_settings")`Project Settings`),
      href: SETTINGS_INSIGHTS,
    };
  }

  if (!user.token) {
    adminLinks.auth = {
      label: (i18n) => i18n._(t("user_menu.login")`Login`),
      href: "/login",
    };
  } else {
    adminLinks.auth = {
      label: (i18n) => i18n._(t("user_menu.logout")`Logout`),
      href: "/logout",
    };
  }

  // AppMenu Link conditions
  if (
    user.access &&
    user.groups !== undefined &&
    user.groups.includes("ConserveIt")
  ) {
    appLinks.push({
      label: (i18n) => i18n._(t("app_chrome.monitoring")`Monitoring`),
      href: "/analysis/monitoring",
    });
  }

  if (user.access && user.access.includes("viewTriagePage")) {
    appLinks.push({
      label: (i18n) => i18n._(t("app_chrome.insights")`Insights`),
      href: "/analysis/insights",
    });
  }

  if (user.token) {
    appLinks.push({
      label: (i18n) => i18n._(t("app_chrome.actions")`Actions`),
      href: "/actions",
    });
  }

  if (user.access && user.access.includes("viewReportGeneratorPage")) {
    appLinks.push({
      label: (i18n) => i18n._(t("app_chrome.reports")`Reports`),
      href: "/reports/performance/workflow",
    });
  }

  if (user.access && user.access.includes('viewSiteDetailsPage') && user.groups && user.groups.includes("iws_api")) {
    appLinks.push({
      label: (i18n) => i18n._(t("app_chrome.site_details")`Site Details`),
      href: "/sitedetails/details",
    });
  }

  return {
    userDetails,
    appLinks,
    adminLinks,
  };
}
